import { LIST_BILLINGS } from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/billing-glosses',
    component: () => import(/* webpackChunkName: "billing-glosses" */ './components/GlossQueue.vue'),
    meta: { layout: 'master', requiresAuth: true, permission: LIST_BILLINGS },
  },
];
